import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Radio from '@mui/material/Radio';
import { Typography } from '@material-ui/core'
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import DatePicker from "react-datepicker"
import { toggleSnackbar } from '../dashboard/store/actions'
import { useDispatch } from 'react-redux'
import * as Endpoint from '../../Endpoint'
import axios from 'axios';
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { TOTAL_SICK_LEAVES, TOTAL_PRIVILEGED_LEAVES } from '../../constants/Leaves'

export default function ApplyLeaveDialogBox(props) {
    const dispatch = useDispatch()
    const {email : userEmail} = useParams()
    const [reasonForLeave, setReasonForLeave] = useState("")
    const [startDate, setStartDate] = useState(new Date().getTime() - 518400000)
    const [endDate, setEndDate] = useState(new Date().getTime() - 518400000)
    const [leaveCategory, setLeaveCategory] = useState("")
    const [open, setOpen] = useState(false)
    const currYear = new Date().getFullYear().toString()

    const [sickLeavesRemaining, setSickLeavesRemaining] = useState(1);
    const [privilegedLeavesRemaining, setPrivilegedLeavesRemaining] = useState(0);
    const [leaveData, setLeaveData] = useState([]); 
    const [userRole, setUserRole] = useState("");
    const [allUsersLeaveData, setAllUsersLeaveData] = useState([]);
    const [openLeaveDetails, setOpenLeaveDetails] = useState(false)

    // Function to fetch user role
    async function fetchUserRole() {
        try {
            const apiUrl = `${Endpoint.API_GET_USER_ROLE}?user_id=${userEmail}`;
            const response = await axios.get(apiUrl, {
                headers: {
                    'X-API-Key': process.env.REACT_APP_API_KEY,
                    'Content-Type': 'application/json',
                },
            });
            const role = response.data.role;
            setUserRole(role);
            return role;
        } catch (error) {
            console.error('Error fetching user role:', error);
            return "";
        }
    }

    // Function to fetch all users' leave data for superadmin
    async function fetchAllUsersLeaveData() {
    try {
        const currentYear = new Date().getFullYear();
        const apiUrl = `${Endpoint.API_ADMIN_ACTIVE_LEAVE_APPLICATIONS}?year=${currentYear}&userid=${userEmail}`;
        
        const response = await axios.get(apiUrl, {
            headers: {
                'X-API-Key': process.env.REACT_APP_API_KEY,
                'Content-Type': 'application/json',
            },
        });

        const leaveApplications = response.data;
        const userLeaveMap = {};

        leaveApplications.forEach(leave => {
            const userId = leave.user_id;
            const category = leave.category || 'sick';

            if (!userLeaveMap[userId]) {
                userLeaveMap[userId] = {
                    user_id: userId,
                    sick_used: 0,
                    privileged_used: 0,
                    sick_remaining: TOTAL_SICK_LEAVES,
                    privileged_remaining: TOTAL_PRIVILEGED_LEAVES
                };
            }

            if (leave.status !== 'rejected') {
                if (category === 'sick') {
                    userLeaveMap[userId].sick_used += leave.days || 0;
                } else if (category === 'privileged') {
                    userLeaveMap[userId].privileged_used += leave.days || 0;
                }
            }
        });

        Object.keys(userLeaveMap).forEach(userId => {
            userLeaveMap[userId].sick_remaining = Math.max(0, TOTAL_SICK_LEAVES - userLeaveMap[userId].sick_used);
            userLeaveMap[userId].privileged_remaining = Math.max(0, TOTAL_PRIVILEGED_LEAVES - userLeaveMap[userId].privileged_used);
        });

        setAllUsersLeaveData(Object.values(userLeaveMap));
        return Object.values(userLeaveMap);
    } catch (error) {
        console.error('Error fetching all users leave data:', error);
        return [];
    }
    }


    async function fetchDetails() {
    try {
        const currentYear = new Date().getFullYear();
        const apiUrl = `${Endpoint.API_USER_ACTIVE_LEAVE_APPLICATIONS}?user_id=${userEmail}&year=${currentYear}`;
        
        const response = await axios.get(apiUrl, {
            headers: {
                'X-API-Key': process.env.REACT_APP_API_KEY,
                'Content-Type': 'application/json',
            },
        });

        const leaveSummary = response.data.leaveSummary;
        const sickLeaveCount = leaveSummary.find(item => item.category === 'sick')?.count || 0;
        const privilegedLeaveCount = leaveSummary.find(item => item.category === 'privileged')?.count || 0;

        setSickLeavesRemaining(TOTAL_SICK_LEAVES - sickLeaveCount);
        setPrivilegedLeavesRemaining(TOTAL_PRIVILEGED_LEAVES - privilegedLeaveCount);

        setLeaveData(response.data.leaveData);

        return response.data.leaveData;
        } catch (error) {
            console.error('Error in fetchDetails:', error);
            throw error;
        }
    }

    const handleClickOpen = async () => {
        try {
            setOpen(true);
            const data = await fetchDetails();
        } catch (error) {
            console.error('Error in handleClickOpen:', error);
           
        }
    };
    
    const handleClose = () => {
        setOpen(false)
    }

    // New handlers for the leave details dialog
    const handleLeaveDetailsOpen = async () => {
        try {
            const role = await fetchUserRole();
            
            if (role === 'Superadmin' || role === 'Admin') {
                await fetchAllUsersLeaveData();
            } else {
                await fetchDetails();
            }
            
            setOpenLeaveDetails(true);
        } catch (error) {
            console.error('Error in handleLeaveDetailsOpen:', error);
        }
    }

    const handleLeaveDetailsClose = () => {
        setOpenLeaveDetails(false)
    }

    const handleStartDateChange = (date) => {
        setStartDate(date)
    }
    const handleEndDateChange = (date) => {
        setEndDate(date)
    }

    const handleReasonChange = (event) => {
        setReasonForLeave(event.target.value)
    }

    const handleCategoryChange = (event) => {
        setLeaveCategory(event.target.value);
    }
    
    const convertDate = (dateInWords) => {
        let processDate = new Date(dateInWords)
        let currYear = processDate.getFullYear()
        let currMonth = parseInt(processDate.getMonth()) + 1
        if (Math.floor(currMonth / 10) === 0) {
            currMonth = '0' + currMonth
        }
        let currDay = processDate.getDate()
        if (Math.floor(currDay / 10) === 0) {
            currDay = '0' + currDay
        }

        return currYear + "-" + currMonth + "-" + currDay;
    }

    const getDaysArray = function (start, end) {
        let arr = []
        for (let date = new Date(start); date <= new Date(end); date.setDate(date.getDate() + 1)) {
            arr.push(convertDate(new Date(date)))
        }
       return arr
    }
    const countWorkingDays = (dates) => {
        return dates.filter(date => {
            const day = new Date(date).getDay(); // Get the day of the week (0 for Sunday, 6 for Saturday)
            return day !== 0 && day !== 6;      // Exclude Sundays (0) and Saturdays (6)
        }).length;
    };
    

    const handleSubmit = () => {
        const dates = getDaysArray(startDate, endDate);
        const status = "pending";
        const reason = reasonForLeave;
        const userId = userEmail;
        const year = currYear;
        const category = leaveCategory;
        if (reason.length === 0 || category.length === 0) {
            const message = reason.length === 0 
                ? "Please enter a reason for taking leave" 
                : "Please choose a category";
                
            dispatch(toggleSnackbar({
                status: true,
                message: message,
                severity: "error"
            }));
            handleClose();
            return;
        }
        const remainingLeaves = category === "sick" 
            ? sickLeavesRemaining 
            : category === "privileged" 
            ? privilegedLeavesRemaining 
            : 0;
    
        const workingDays = countWorkingDays(dates);

        if (workingDays > remainingLeaves && leaveCategory !== "paid") {
            dispatch(toggleSnackbar({
                status: true,
                message: `You have only ${remainingLeaves} ${category} leaves remaining.`,
                severity: "error"
            }));
            handleClose();
            return;
        }
        props.handleApplyLeave(dates, status, reason, userId, year, category);
        handleClose();
    };
    
    const isPaidLeaveDisabled = sickLeavesRemaining > 0 || privilegedLeavesRemaining > 0;
    

    return (
        <div>
            <div >
                <button className="user-apply-leave-button util--btn" onClick={handleClickOpen}>
                    Apply For Leave
                </button>

                <button
                    className="user-view-leave-button util--btn"
                    onClick={handleLeaveDetailsOpen}
                    style={{
                        fontSize: '16px',
                        fontFamily: 'Inter, sans-serif',
                        fontStyle: 'normal',
                        fontWeight: '500',
                        height: '2.5rem',
                        width: '12rem',
                        border: 'none',
                        cursor: 'pointer',
                        backgroundColor: '#f3795e',
                        color: '#ECF0F3',
                        borderRadius: '10px',
                        marginLeft: '1rem',
                        transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.cursor = 'pointer';
                        e.target.style.backgroundColor = '#f3795e';
                        e.target.style.transform = 'scale(1.05)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.backgroundColor = '#f3795e';
                        e.target.style.transform = 'scale(1)';
                    }}
                >
                    View Leave Details
                </button>


            </div>
            <Dialog className="leave-dialog-box" open={open} onClose={handleClose}>
                <div className="user-apply-leave-dialog">
                    <h4 style={{ color: '#4B566C' }}>
                        NOTE: If the leave is for a single day, please keep the start and end date same.
                    </h4>
                    <DialogContent>
                        <div className="leave-dialog-datepickers">
                            <DatePicker fullWidth selected={startDate} onChange={handleStartDateChange} />
                            <DatePicker fullWidth selected={endDate} onChange={handleEndDateChange} minDate={startDate}  />
                        </div>
                        <TextField
                            margin="dense"
                            id="name"
                            label="Enter the reason for taking leave"
                            type="text"
                            fullWidth
                            variant="standard"
                            onChange={handleReasonChange}
                        />
                        <h4 style={{ color: '#4B566C', marginTop: '20px' }}>Category</h4>
                        <RadioGroup
                            row
                            aria-labelledby="leave-category-group-label"
                            defaultValue="sick"
                            name="leave-category-group"
                            value={leaveCategory}
                            onChange={handleCategoryChange}
                            style={{ marginTop: '10px', color: '#4B566C' }}
                        >
                            <FormControlLabel
                                value="sick"
                                control={<Radio />}
                                disabled={sickLeavesRemaining === 0}
                                label={<Typography variant="body1" sx={{ fontWeight: 'bold' }}> Sick Leave ({sickLeavesRemaining>0?sickLeavesRemaining:0})</Typography>}
                                sx={{
                                    opacity: sickLeavesRemaining === 0 ? 0.5 : 1,  
                                    filter: sickLeavesRemaining === 0 ? 'blur(1px)' : 'none', 
                                }}
                            />
                            <FormControlLabel
                                value="privileged"
                                control={<Radio />}
                                label={<Typography variant="body1" sx={{ fontWeight: 'bold' }}>Privileged Leave({privilegedLeavesRemaining>0?privilegedLeavesRemaining:0})</Typography>}
                                disabled={privilegedLeavesRemaining === 0} 
                                sx={{
                                    opacity: privilegedLeavesRemaining === 0 ? 0.5 : 1,  
                                    filter: privilegedLeavesRemaining === 0 ? 'blur(1px)' : 'none', 
                                }}
                            />
                            <FormControlLabel
                                value="paid"
                                control={<Radio />}
                                label={<Typography variant="body1" sx={{ fontWeight: 'bold' }}>Paid Leave</Typography>}
                                disabled={isPaidLeaveDisabled} 
                                sx={{
                                    opacity: isPaidLeaveDisabled ? 0.5 : 1, 
                                    filter: isPaidLeaveDisabled ? 'blur(1px)' : 'none', 
                                }}
                            />
                        </RadioGroup>
                    </DialogContent>
                    <DialogActions>
                        <Button sx={{color : '#f3795e'}} onClick={handleClose}>Cancel</Button>
                        <Button sx={{ color: '#f3795e' }} onClick={handleSubmit}>Apply</Button>
                    </DialogActions>
                </div>
            </Dialog>

            {/* Leave Details Dialog */}
            <Dialog
                open={openLeaveDetails}
                onClose={handleLeaveDetailsClose}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>
                    {userRole === 'Superadmin' || userRole === 'Admin' 
                        ? 'All Users Leave Details' 
                        : `Leave Details for ${userEmail}`
                    }
                </DialogTitle>
                <DialogContent>
                    <TableContainer component={Paper}>
                        <Table aria-label="leave details table">
                            <TableHead>
                                <TableRow  sx={{ 
                                '& th': {
                                    backgroundColor: '#f3795e !important',
                                    color: '#fff',
                                    fontFamily: 'Inter, sans-serif',
                                    fontWeight: 600,
                                    fontSize: '14px',
                                    textAlign: 'center',                                  
                                },
                            }}>
                                    <TableCell>User Email</TableCell>
                                    <TableCell>Category</TableCell>           
                                    <TableCell>Allowed</TableCell>
                                    <TableCell>Used</TableCell>
                                    <TableCell>Balanced</TableCell>
                                    <TableCell>Year</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {userRole === 'Superadmin' || userRole === 'Admin' ? (
                                    // Show all users' leave data for Superadmin/Admin
                                    allUsersLeaveData.length > 0 ? (
                                        allUsersLeaveData.map((userData) => (
                                            <React.Fragment key={userData.user_id}>
                                                <TableRow>
                                                    <TableCell align='center' sx={{ width: '23%', whiteSpace: 'nowrap' }}>
                                                        {userData.user_id}
                                                    </TableCell>
                                                    <TableCell align='center'>Sick</TableCell>
                                                    <TableCell align='center'>{TOTAL_SICK_LEAVES}</TableCell>
                                                    <TableCell align='center'>{userData.sick_used}</TableCell>
                                                    <TableCell align='center'>{userData.sick_remaining}</TableCell>
                                                    <TableCell align='center'>{new Date().getFullYear()}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align='center' sx={{ width: '23%', whiteSpace: 'nowrap' }}>
                                                        {userData.user_id}
                                                    </TableCell>
                                                    <TableCell align='center'>Privileged</TableCell>
                                                    <TableCell align='center'>{TOTAL_PRIVILEGED_LEAVES}</TableCell>
                                                    <TableCell align='center'>{userData.privileged_used}</TableCell>
                                                    <TableCell align='center'>{userData.privileged_remaining}</TableCell>
                                                    <TableCell align='center'>{new Date().getFullYear()}</TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">No leave data available</TableCell>
                                        </TableRow>
                                    )
                                ) : (
                                    // Show current user's leave data for regular users
                                    leaveData.length > 0 ? (
                                        <>
                                            <TableRow>
                                                <TableCell align='center' sx={{ width: '23%', whiteSpace: 'nowrap' }}>{userEmail}</TableCell>
                                                <TableCell align='center'>Sick</TableCell>
                                                <TableCell align='center'>{TOTAL_SICK_LEAVES}</TableCell>
                                                <TableCell align='center'>{TOTAL_SICK_LEAVES - sickLeavesRemaining}</TableCell>
                                                <TableCell align='center'>{sickLeavesRemaining}</TableCell>
                                                <TableCell align='center'>{new Date().getFullYear()}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align='center' sx={{ width: '23%', whiteSpace: 'nowrap' }}>{userEmail}</TableCell>
                                                <TableCell align='center'>Privileged</TableCell>
                                                <TableCell align='center'>{TOTAL_PRIVILEGED_LEAVES}</TableCell>
                                                <TableCell align='center'>{TOTAL_PRIVILEGED_LEAVES - privilegedLeavesRemaining}</TableCell>
                                                <TableCell align='center'>{privilegedLeavesRemaining}</TableCell>
                                                <TableCell align='center'>{new Date().getFullYear()}</TableCell>
                                            </TableRow>
                                        </>
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6} align="center">No leave data available</TableCell>
                                        </TableRow>
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLeaveDetailsClose} sx={{ color: '#f3795e' }}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}